import React, { useContext, useState, useEffect } from 'react'

import Pagination from '@mui/material/Pagination'
import { Grid, Container } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { withTranslation } from 'react-i18next'

import ListingCard from '../common/ListingCard'
import LoadingListingCard from './LoadingListingCard'

import { store } from '../../store/app/Store'

const ListingsSection = (props) => {
  const theme = useTheme()
  const globalState = useContext(store)
  const { state } = globalState

  const styles = {
    subtitle: {
      marginTop: `-1rem`,
    },
    listing: {
      padding: theme.spacing(2),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  }

  const isSmall = window.innerWidth < 1200

  const [page, setPage] = useState(1)
  const [listings, setListings] = useState(state.drawerListings?.data || [])
  const [loading, setLoading] = useState(
    state.drawerListings?.status === 'loaded' ? false : true
  )

  // Number of listings per page
  const listingsPerPage = 8
  const pageCount = Math.ceil(listings.length / listingsPerPage)

  // Slice listings for pagination
  const paginatedListings = listings.slice(
    (page - 1) * listingsPerPage,
    page * listingsPerPage
  )

  useEffect(() => {
    if (state.drawerListings?.data?.length > 0) {
      setListings(state.drawerListings.data)
      setLoading(false)
    }
  }, [state.drawerListings])

  return (
    <section style={styles.listing}>
      <Container>
        <Grid
          container
          spacing={4}
          justifyContent="center"
          alignItems="center"
          sx={{
            flexDirection: {
              xs: 'column',
              sm: 'row',
            },
          }}
        >
          {loading
            ? Array.from({ length: listingsPerPage }).map((_, index) => (
                <Grid item xs={12} sm={12} md={6} key={index}>
                  <LoadingListingCard smallMode={isSmall} />
                </Grid>
              ))
            : paginatedListings.map((listing, index) => (
                <Grid item xs={12} sm={12} md={6} key={index}>
                  <ListingCard data={listing} color={'#054D85'} />
                </Grid>
              ))}
        </Grid>

        {pageCount > 1 && (
          <Pagination
            count={pageCount}
            color="primary"
            page={page}
            onChange={(event, value) => setPage(value)}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: '2rem',
            }}
            size="small"
            siblingCount={0}
          />
        )}

        <Grid item xs={12} style={{ marginTop: `2rem` }}>
          <p>
            <small>
              <a
                href="https://homewiserealestate.ca/contact"
                target="_blank"
                rel="noopener noreferrer"
                className="link"
              >
                Contact
              </a>
              {' - '}
              <a
                href="https://thinkhomewise.com/page/terms/"
                target="_blank"
                rel="noopener noreferrer"
                className="link"
              >
                Terms of Use
              </a>
              {' - '}
              <a
                href="https://thinkhomewise.com/page/privacy/"
                target="_blank"
                rel="noopener noreferrer"
                className="link"
              >
                Privacy Policy
              </a>
            </small>
          </p>
          <p style={{ fontSize: `0.7rem`, lineHeight: `.9rem` }}>
            REALTOR®, REALTORS®, and the REALTOR® logo are certification marks
            that are owned by REALTOR® Canada Inc. and licensed exclusively to
            The Canadian Real Estate Association (CREA). These certification
            marks identify real estate professionals who are members of CREA and
            who must abide by CREA's By-Laws, Rules, and the REALTOR® Code. The
            MLS® trademark and the MLS® logo are owned by CREA and identify the
            quality of services provided by real estate professionals who are
            members of CREA.
          </p>
        </Grid>
      </Container>
    </section>
  )
}

export default withTranslation('common')(ListingsSection)
